import stockApi from '../../services/StockApi'
import httpRaspberrySoul from 'src/infrastructure/httpRaspberrySoul'
import httpRemotePrinterRaspberrySoul from 'src/infrastructure/httpRemotePrinterRaspberrySoul'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  FractionTag, GenericApiErrors, PrintFractionTagPayload, ScaleWeight,
} from './FractionTypes'
import http from 'src/infrastructure/http'
import { camelCase } from 'change-case'

const removeFraction = async (id_fraction, userBadge) => {
  const axiosConfig = {
    headers: {
      'user-barcode': userBadge,
    },
    data: {
      id_fraction,
    },
  }

  const { data } = await stockApi.delete('/receivement/fraction', axiosConfig)

  return data
}

const setLotTotalLoss = async (id_batch, userBadge) => {
  const axiosConfig = {
    headers: {
      'user-barcode': userBadge,
    },
  }

  const { data } = await stockApi.post(
    'v2/recebimento/fraction/total-loss',
    { id_batch },
    axiosConfig,
  )

  return data
}

const getScaleWeight = async () => {
  try {
    const result = await httpRaspberrySoul.get('/scale/weight')

    return parseGoodResponse<ScaleWeight>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const checkLocalRaspberryStatus = async () => {
  try {
    const result = await httpRaspberrySoul.get('/health')

    return parseGoodResponse<any>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const checkRemotePrinterStatus = async () => {
  try {
    const result = await httpRemotePrinterRaspberrySoul.get('/health')

    return parseGoodResponse<any>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const getActiveFractionTagData = async () => {
  try {
    const result = await http.get('/v2/recebimento/fraction/tag')

    return parseGoodResponse<FractionTag>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const printFractionTag = async (data: PrintFractionTagPayload, fractionTag: FractionTag) => {
  try {
    const payload = {
      tag_id: fractionTag.tagName,
      fields: fractionTag.fields.map((field) => {
        const fieldNameCamelCase = camelCase(field.fieldName)
        return ({
          type: field.fieldType,
          position: [field.positionX, field.positionY],
          field_name: field.fieldName,
          value: data[fieldNameCamelCase],
        })
      }),
    }

    const result = await httpRemotePrinterRaspberrySoul.post('/fractioning/print', payload)

    return parseGoodResponse<any>(result.data)
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

const pauseFractioning = async (idBatch: number, badge: string) => {
  try {
    const body = {
      id_batch: idBatch,
    }

    await http.post('/v2/recebimento/fraction/pause', body, {
      headers: { 'user-barcode': badge },
    })

    return parseGoodResponse<never>()
  } catch (err: any) {
    return parseFailedResponse<any, any>(GenericApiErrors.Failed, err.response)
  }
}

export default {
  removeFraction,
  setLotTotalLoss,
  getScaleWeight,
  checkLocalRaspberryStatus,
  checkRemotePrinterStatus,
  getActiveFractionTagData,
  printFractionTag,
  pauseFractioning,
}
